import React, { useState } from 'react'
import { PhotoCamera } from '@material-ui/icons'
import SimpleActionPopup from '../../../components/SimpleActionPopup'
import FormInput from '../../../components/FormInput'

const ProductPopup = ({ subgroup, product, onClose, onSubmit, isLoading }) => {
  const [file, setFile] = useState(null)
  const [preview, setPreview] = useState(product ? product.url : null) 
  const [data, setData] = useState({
    title_pt: product ? product.title_pt : '',
    link: product ? product.link : '',
    rank: product ? product.rank : 0
  })

  const handleImageChange = (e) => {
    const selectedFile = e.target.files[0]
    if (selectedFile) {
      setFile(selectedFile)
      setPreview(URL.createObjectURL(selectedFile))

      // Se o campo de título estiver vazio, preenchemos com o nome do arquivo
      if (!data.title_pt) {
        // 1. Remove a extensão (pega tudo antes do último ponto)
        let fileName = selectedFile.name.split('.').slice(0, -1).join('.')
        
        // 2. Limpeza estética: troca underlines e hifens por espaços
        fileName = fileName.replace(/[_-]/g, ' ')
        
        // 3. Opcional: Colocar a primeira letra de cada palavra em maiúsculo
        const formattedName = fileName.charAt(0).toUpperCase() + fileName.slice(1)

        setData(prev => ({
          ...prev,
          title_pt: formattedName
        }))
      }
    }
  }
  
  const handleCreate = () => {
    onSubmit({ ...data, file })
  }

  const content = (
    /* Grid horizontal para manter o padrão largo e baixo */
    <div className='grid grid-cols-1 md:grid-cols-12 gap-8 p-4 min-w-[300px] md:min-w-[650px]'>
      
      {/* LADO ESQUERDO: Upload da Foto do Produto */}
      <div className="md:col-span-5 flex flex-col items-center justify-center border-2 border-dashed border-gray-300 rounded-2xl bg-gray-50 hover:bg-gray-100 transition-all p-4 h-full min-h-[220px]">
        {preview ? (
          <div className="relative group">
            <img src={preview} className="w-40 h-40 object-contain rounded-xl shadow-md border-2 border-white bg-white" alt="preview" />
            <div className="absolute inset-0 bg-black bg-opacity-30 rounded-xl opacity-0 group-hover:opacity-100 flex items-center justify-center transition-opacity cursor-pointer">
              <PhotoCamera className="text-white" />
            </div>
          </div>
        ) : (
          <div className="text-center">
            <PhotoCamera className="text-gray-300" style={{ fontSize: 50 }} />
            <p className="text-gray-400 text-[10px] mt-2 font-bold uppercase tracking-wider">Foto do Produto</p>
          </div>
        )}
        
        <label className="mt-4 cursor-pointer bg-white border border-purple-200 px-4 py-2 rounded-xl text-[11px] font-black text-purple-600 shadow-sm hover:shadow-md transition-all active:scale-95">
          {preview ? 'ALTERAR FOTO' : 'SELECIONAR FOTO'}
          <input type="file" className="hidden" accept="image/*" onChange={handleImageChange} />
        </label>
      </div>

      {/* LADO DIREITO: Campos do Produto */}
      <div className="md:col-span-7 flex flex-col justify-center gap-y-3">
        <FormInput 
          label="Nome do Produto (PT)*" 
          placeholder="Ex: Batom Líquido Matte Red"
          value={data.title_pt} 
          onChange={e => setData({...data, title_pt: e.target.value})} 
        />

        <FormInput 
          label="Link de Compra / Detalhes" 
          placeholder="https://..."
          value={data.link} 
          onChange={e => setData({...data, link: e.target.value})} 
        />
        
        <div className="grid grid-cols-2 gap-4">
          <FormInput 
            label="Ordem (Rank)" 
            type="number"
            value={data.rank} 
            onChange={e => setData({...data, rank: e.target.value})} 
          />
          
          <div className="flex flex-col justify-end pb-2">
            <p className="text-[10px] text-gray-400 leading-tight">
              O produto será vinculado à categoria <strong>{subgroup?.title_pt}</strong>.
            </p>
          </div>
        </div>
      </div>
    </div>
  )

  return (
    <SimpleActionPopup
      title={product ? `Editar Item em ${subgroup?.title_pt}` : `Novo Produto em ${subgroup?.title_pt}`}
      secondActionButtonText={product ? "SALVAR ALTERAÇÕES" : "ADICIONAR PRODUTO"}
      content={content}
      onClosePopup={onClose}
      onPressSecondActionButton={handleCreate}
      popupLoading={isLoading}
      containerStyle={{ 
        maxWidth: '850px', 
        width: '90vw', 
        minHeight: 'auto' 
      }}
    />
  )
}

export default ProductPopup